import React, { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import {API_URL} from "../utils/api";
import axios  from "axios";

const AddGalleryLayer = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
 // const [postimagePreview, setPostImagePreview] = useState(null);
  const [title, setTitle] = useState("");
  const [thumbnail, setThumbnail] = useState("");
 // const [postthumbnail, setPostThumbnail] = useState("");

  const [titleErr, setTitleErr] = useState(false);
  const [thumbnailErr, setThumbnailErr] = useState(false);
//  const [postthumbnailErr, setPostThumbnailErr] = useState(false);
 
  const handleRemoveImage = () => {
    setImagePreview(null);
    setThumbnailErr(true);
  };
/*  const handleRemovePostImage = () => {
    setPostImagePreview(null);
    setPostThumbnailErr(true);

  };*/
 
 
  const handleFileChange = async(e) => {
    if (e.target.files && e.target.files.length > 0) {
      var targetFile = e.target.files[0];
      const src = URL.createObjectURL(targetFile);
      setThumbnail(targetFile);
      setImagePreview(src);
      setThumbnailErr(false);
 
    }
  };

  /*const handlePostFileChange = async(e) => {
    if (e.target.files && e.target.files.length > 0) {
      var targetFile = e.target.files[0];
      const src = URL.createObjectURL(targetFile);
      setPostThumbnail(targetFile);
      setPostImagePreview(src);
      setPostThumbnailErr(false);

    }
  };*/
  
  const handleSubmit = () => {
    
    if(title != "" && thumbnail != ""){
    var formData = {
      title : title,
      image : thumbnail,
      post_image : ""
    };
    console.log(formData);
    axios.post(process.env.REACT_APP_API_BASE_URL+"gallery-add", { ...formData }, {
      headers: {
        "content-type": "multipart/form-data"
      },
      
    })
      .then((res) => {
          console.log(res.data);
          // return false;
        if(res.data.status === true){
            toast.success('Record added sucessfully!!');
            setTimeout(() => {
              navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/gallery');
            }, 2000);
        }
        else{
          alert("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });

    } else {
     
      if(title == ""){
        setTitleErr(true);
      }
      if(thumbnail == ""){
        setThumbnailErr(true);
      } 
     /* if(postthumbnail == ""){
        setPostThumbnailErr(true);
      }*/
  
    }
  }

  

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Add Gallery</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Title:{" "}
                </label>
                <input
                  onChange={(e) => {
                    setTitle(e.target.value)
                    setTitleErr(true);
                    if(e.target.value !== ""){
                      setTitleErr(false);
                    }
                  
                  }}
                  type='text'
                  className={titleErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                   id='title'
                  placeholder='Enter Title'
                />
                 {titleErr && (
                        <span className="error-message">
                            {'Title is mandatory'}
                        </span>
                    )} 
              </div>
              
              
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Before Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemoveImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-file'
                        type='file'
                        hidden
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
                  {thumbnailErr && (
                        <span className="error-message">
                            {'Attachment is mandatory'}
                        </span>
                    )}
                </div>
              </div>
              
              {/*<div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Post Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {postimagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemovePostImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={postimagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-post-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-post-file'
                        type='file'
                        hidden
                        onChange={handlePostFileChange}
                      />
                    </label>
                  )}
                  {postthumbnailErr && (
                        <span className="error-message">
                            {'Post Attachment is mandatory'}
                        </span>
                    )}
                </div>
              </div>*/}
              
              <br></br>
              <button onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddGalleryLayer;
